export enum education_institution {
    'Centro De Formación Técnica Accioma',
    'Centro De Formación Técnica Alfa',
    'Centro De Formación Técnica Alpes',
    'Centro De Formación Técnica Barros Arana',
    'Centro De Formación Técnica Ceduc - Ucn',
    'Centro De Formación Técnica Ceitec',
    'Centro De Formación Técnica Cenco',
    'Centro De Formación Técnica Centro De Enseñanza De Alta Costura Paulina Diard',
    'Centro De Formación Técnica Centro Tecnológico Superior Infomed',
    'Centro De Formación Técnica Cámara De Comercio De Santiago',
    'Centro De Formación Técnica De Enac O Centro De Formación Técnica De Los Establecimientos Nacionales De Educación Cáritas-Chile',
    'Centro De Formación Técnica De La Industria Gráfica O Cft. Ingraf',
    'Centro De Formación Técnica De La Pontificia Universidad Católica De Valparaíso O Cft Pucv',
    'Centro De Formación Técnica De La Región De Coquimbo',
    'Centro De Formación Técnica De La Región De La Araucanía',
    'Centro De Formación Técnica De La Región De Los Lagos',
    'Centro De Formación Técnica De La Región De Tarapacá',
    'Centro De Formación Técnica De La Región Del Maule',
    'Centro De Formación Técnica De La Universidad De Valparaíso O Cft Uv',
    'Centro De Formación Técnica De Tarapacá',
    'Centro De Formación Técnica Del Medio Ambiente',
    'Centro De Formación Técnica Educap',
    'Centro De Formación Técnica Escuela Culinaria Francesa',
    'Centro De Formación Técnica Escuela Superior De Administración De Negocios Del Norte - Esane Del Norte ',
    'Centro De Formación Técnica Estudio Profesor Valero',
    'Centro De Formación Técnica Icel',
    'Centro De Formación Técnica Inacap',
    'Centro De Formación Técnica Instituto Central De Capacitación Educacional Icce',
    'Centro De Formación Técnica Instituto Superior Alemán De Comercio Insalco',
    'Centro De Formación Técnica Instituto Superior De Estudios Jurídicos Canon',
    'Centro De Formación Técnica Instituto Técnológico De Chile - I.T.C.',
    'Centro De Formación Técnica Iprosec',
    'Centro De Formación Técnica Juan Bohon',
    'Centro De Formación Técnica Laplace O C.F.T.  De Estudios Superiores Y Capacitación Profesional Laplace',
    'Centro De Formación Técnica Los Lagos',
    'Centro De Formación Técnica Lota-Arauco',
    'Centro De Formación Técnica Manpower',
    'Centro De Formación Técnica Massachusetts',
    'Centro De Formación Técnica Proandes',
    'Centro De Formación Técnica Prodata',
    'Centro De Formación Técnica Profasoc',
    'Centro De Formación Técnica Protec',
    'Centro De Formación Técnica San Agustín De Talca',
    'Centro De Formación Técnica Santo Tomás',
    'Centro De Formación Técnica Teodoro Wickel Kluwen',
    'Instituto Nacional De Capacitación Profesional Inacap',
    'Instituto Profesional Adventista',
    'Instituto Profesional Agrario Adolfo Matthei',
    'Instituto Profesional Aiep',
    'Instituto Profesional Alemán Wilhelm Von Humboldt',
    'Instituto Profesional Carlos Casanueva',
    'Instituto Profesional Ciisa',
    'Instituto Profesional De Arte Y Comunicación Arcos',
    'Instituto Profesional De Artes Escénicas Karen Connolly',
    'Instituto Profesional De Chile',
    'Instituto Profesional De Ciencias De La Computación Acuario Data',
    'Instituto Profesional De Ciencias Y Educación Helen Keller',
    'Instituto Profesional De Los Angeles',
    'Instituto Profesional Del Comercio',
    'Instituto Profesional Del Valle Central',
    'Instituto Profesional Diego Portales',
    'Instituto Profesional Dr. Virginio Gómez G.',
    'Instituto Profesional Duoc Uc',
    'Instituto Profesional Eatri Instituto Profesional',
    'Instituto Profesional Escuela De Cine De Chile',
    'Instituto Profesional Escuela De Contadores Auditores De Santiago',
    'Instituto Profesional Escuela De Marina Mercante Piloto Pardo',
    'Instituto Profesional Escuela Moderna De Música',
    'Instituto Profesional Esucomex',
    'Instituto Profesional Inacap O Instituto Profesional',
    'Instituto Profesional Instituto De Estudios Bancarios Guillermo Subercaseaux',
    'Instituto Profesional Instituto Internacional De Artes Culinarias Y Servicios',
    'Instituto Profesional Instituto Nacional Del Fútbol',
    'Instituto Profesional Instituto Superior De Artes Y Ciencias De La Comunicación',
    'Instituto Profesional Ipg',
    'Instituto Profesional La Araucana',
    'Instituto Profesional Latinoamericano De Comercio Exterior - Iplacex',
    'Instituto Profesional Libertador De Los Andes',
    'Instituto Profesional Los Lagos',
    'Instituto Profesional Los Leones',
    'Instituto Profesional Projazz',
    'Instituto Profesional Providencia',
    'Instituto Profesional Santo Tomás',
    'Instituto Profesional Vertical Instituto Profesional',
    'Pontificia Universidad Católica De Chile',
    'Pontificia Universidad Católica De Valparaíso',
    'Universidad Academia De Humanismo Cristiano',
    'Universidad Adolfo Ibañez',
    'Universidad Adventista De Chile',
    'Universidad Alberto Hurtado',
    'Universidad Andrés Bello',
    'Universidad Arturo Prat',
    'Universidad Austral De Chile',
    'Universidad Autónoma De Chile',
    'Universidad Bernardo O\'Higgins',
    'Universidad Bolivariana',
    'Universidad Católica Cardenal Raúl Silva Henríquez',
    'Universidad Católica De La Santísima Concepción',
    'Universidad Católica De Temuco',
    'Universidad Católica Del Maule',
    'Universidad Católica Del Norte',
    'Universidad Central De Chile',
    'Universidad De Aconcagua',
    'Universidad De Antofagasta',
    'Universidad De Artes, Ciencias Y Comunicación - Uniacc',
    'Universidad De Atacama',
    'Universidad De Aysén',
    'Universidad De Chile',
    'Universidad De Concepción',
    'Universidad De La Frontera',
    'Universidad De La Serena',
    'Universidad De Las Américas',
    'Universidad De Los Andes',
    'Universidad De Los Lagos',
    'Universidad De Magallanes',
    'Universidad De O\'Higgins',
    'Universidad De Playa Ancha De Ciencias De La Educación',
    'Universidad De Santiago De Chile',
    'Universidad De Talca',
    'Universidad De Tarapacá',
    'Universidad De Valparaíso',
    'Universidad De Viña Del Mar',
    'Universidad Del Bío-Bío',
    'Universidad Del Desarrollo',
    'Universidad Del Pacífico',
    'Universidad Diego Portales',
    'Universidad Finis Terrae',
    'Universidad Gabriela Mistral',
    'Universidad La República',
    'Universidad Los Leones',
    'Universidad Mayor',
    'Universidad Metropolitana De Ciencias De La Educación',
    'Universidad Miguel De Cervantes',
    'Universidad Pedro De Valdivia',
    'Universidad San Sebastián',
    'Universidad Santo Tomás',
    'Universidad Sek',
    'Universidad Tecnológica De Chile Inacap',
    'Universidad Tecnológica Metropolitana',
    'Universidad Técnica Federico Santa María',
    'Universidad Ucinf',
}
